import { useTranslation } from 'hooks/useTranslation';

type Props = {
  service: string;
  spacing?: string;
};

export const EmbedPlaceholder = ({
  service,
  spacing = 'm-4',
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      className={`text-center text-white flex flex-col justify-center items-center p-1 cursor-pointer ${spacing}`}
      style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
      title="Open cookie settings"
      onClick={() => {
        // eslint-disable-next-line
        // @ts-ignore
        if (window && window.UC_UI) {
          // eslint-disable-next-line
          // @ts-ignore
          window.UC_UI.showSecondLayer();
        }
      }}
    >
      <p>{t('embedPlaceholder.text1', { service })}</p>
      <p>
        <small>{t('embedPlaceholder.text2')}</small>
      </p>
    </div>
  );
};
